import styles from "./AddonItem.module.scss";
import React, { useState } from "react";
import { IAddon, IModelForBuyingAddon } from "../../../../../models/Addon";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../../components/ui/CustomButton/CustomButton";
import paymentIcon from "../../../../../assets/images/icons/payment-icon.svg";
import useAppSelector from "../../../../../hooks/useAppSelector";
import ConfirmPopup from "../../../../../components/shared/ConfirmPopup/ConfirmPopup";
import { handleError } from "../../../../../helper/errorHandler";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import { PaymixService } from "../../../../../services/paymix.service";
import { openErrorMessage } from "../../../../../store/message/messageSlice";
import { useNavigate } from "react-router-dom";
import { UserSubscriptionService } from "../../../../../services/userSubscription.service";
import { setUserSubscription } from "../../../../../store/userSubscription/userSubscriptionSlice";

interface IAddonItemProps {
  item: IAddon;
}

const AddonItem: React.FC<IAddonItemProps> = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.userProfileSlice);
  const { defaultPaymentMethod } = useAppSelector((state) => state.userPaymentMethodsSlice);

  const [confirmPopupVisible, setConfirmPopupVisible] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);

  if (!user || !defaultPaymentMethod) {
    return null;
  }

  const getUserSubscription = async (userId: string) => {
    try {
      const response = await UserSubscriptionService.getUserSubscriptionByUserId(userId);
      dispatch(setUserSubscription(response.data));
    } catch (e) {}
  };

  const onClickYes = async () => {
    if (!user) {
      return;
    }

    // TODO maybe change the logic
    if (!defaultPaymentMethod) {
      navigate("/settings/billing");
      return;
    }
    const model: IModelForBuyingAddon = {
      userId: user.id,
      paymentMethodId: defaultPaymentMethod.id,
      addonId: item.id,
      loyaltyExchangeId: null,
      // TODO change redirect url
      redirectUrl: "https://clubpass.gr",
    };
    setButtonLoader(true);
    try {
      const { data } = await PaymixService.buyAddon(model);
      if (data.isSuccess) {
        if (data.redirectUrl) {
          window.open(data.redirectUrl, "_blank");
        } else {
          await getUserSubscription(model.userId);
          setConfirmPopupVisible(false);
        }
      } else {
        dispatch(openErrorMessage(t("FailedToBuySubscription")));
      }
    } catch (e) {
      handleError(e, dispatch, t);
    }
    setButtonLoader(false);
  };

  const onClickNo = () => {
    setConfirmPopupVisible(false);
  };

  return (
    <>
      <div className={styles.item}>
        <div className={styles.row}>
          <p className={styles.credits}>
            {item.credits} {t("Credits")}
          </p>
          <p className={styles.price}>€{item.price}</p>
        </div>
        <CustomButton
          text={t("BuyNow")}
          type={"button"}
          typeStyle={"fill"}
          style={{ borderRadius: "5px" }}
          functionOnClick={() => setConfirmPopupVisible(true)}
        />
      </div>
      {confirmPopupVisible && (
        <ConfirmPopup
          iconPath={paymentIcon}
          title={t("ConfirmYourPayment")}
          description={t("YouAreAboutToCompleteYourPurchase") + "."}
          onClickYes={onClickYes}
          onClickNo={onClickNo}
          yesButtonLoader={buttonLoader}
        />
      )}
      {/*{*/}
      {/*    confirmPopupVisible && (*/}
      {/*        <StripeElements>*/}
      {/*            <ConfirmPopupWithStripe*/}
      {/*                iconPath={paymentIcon}*/}
      {/*                title={t("ConfirmYourPayment")}*/}
      {/*                description={t("YouAreAboutToCompleteYourPurchase") + "."}*/}
      {/*                onClickYes={onClickYes}*/}
      {/*                onClickNo={onClickNo}*/}
      {/*                modelForAddon={{addonId: item.id, userId: user.id, paymentMethodId: defaultPaymentMethod.id}}*/}
      {/*                additionalDescription={`${item.credits} ${t("credits")} ${t("for")} €${item.price}`}*/}
      {/*                textForRejectBtn={t("Cancel")}*/}
      {/*                textForConfirmBtn={t("Continue")}*/}
      {/*            />*/}
      {/*        </StripeElements>*/}
      {/*    )*/}
      {/*}*/}
    </>
  );
};

export default AddonItem;
